'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'my_trips_login',
    modelClass: require('./model'),
    viewClass: require('./view'),

    methods: {
        getTripOk: function(data) {
            this._loadTrip(data);
        },

        getTripError: function(data) {
            this._loadTripError(data);
        },

        actionsHandler: function(data) {
            this.actionsHandler(data);
        },
    },
});
